/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import { getTargetingTooltip } from 'utils/helpers';
import { blockStyles } from '../../../../../components/Block';
import { FilterButton } from './FilterButton';
import { AdvancedTargetingOptionKeys } from '../../../../../store/advancedTargeting/constants';

interface Props {
  filters: AdvancedTargetingOptionKeys[];
  handleChange: (key: AdvancedTargetingOptionKeys) => (param: string) => void;
  handleCSVUpload: (key: AdvancedTargetingOptionKeys) => (param: FileList) => void;
  targetingType: 'targeted' | 'blocked';
}

export const FilterList = (props: Props) => {
  const { filters, handleChange, handleCSVUpload, targetingType } = props;
  return (
    <div data-qa="356" className={blockStyles.blockRow}>
      <div data-qa="357" className={`${blockStyles.input} ${blockStyles.first}`}>
        <label data-qa="358" className={`text-label ${blockStyles.inputLabel}`} />
        <div data-qa="360" className={`${blockStyles.inputButtons} row w-100 pl-3`}>
          {filters.map((filter) => (
            <FilterButton
              filter={filter}
              key={filter}
              handleChange={handleChange(filter)}
              handleCSVUpload={handleCSVUpload(filter)}
              uiNoteTooltip={getTargetingTooltip(targetingType, filter)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
